
// Base.
import Component from 'vue-class-component'
import Vue from 'vue'
import {Watch} from 'vue-property-decorator'
import {State} from 'vuex-class'

// Used Models.
import {GenericUser, User} from '../models/user'
import GridHeader from '../models/gridHeader'

// Used Components.
import AssignService from '../components/Users/AssignService.vue'
import CardTable from '../components/Layout/CardTable.vue'
import ChangeEmail from '../components/ChangeEmail.vue'
import CsvExport from '../components/Users/CsvExport.vue'
import DisplayActivationKey from '../components/Users/DisplayActivationKey.vue'
import DatePickerActions from '@/components/Atomic/DatePickerActions.vue'
import EnableWifi from '../components/Users/EnableWifi.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import RedButton from '@/components/Atomic/RedButton.vue'
import ResetPassword from '../components/Users/ResetPassword.vue'
import ResetSinglePassword from '../components/Users/ResetSinglePassword.vue'
import SearchField from '@/components/Atomic/SearchField.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import BlueButton from '@/components/Atomic/BlueButton.vue'

import StartMission from '../components/UsersMireo/StartMission.vue'
import EndMission from '../components/UsersMireo/EndMission.vue'

import TempAccountCreate from '@/components/TempAccounts/TempAccountCreate.vue'
import TempAccountUpdate from '@/components/TempAccounts/TempAccountUpdate.vue'
import TempAccountChangeStatus from '@/components/TempAccounts/TempAccountChangeStatus.vue'
import TempAccountDelete from '@/components/TempAccounts/TempAccountDelete.vue'

import Establishment from '@/models/establishment'
import TempAccount from '@/models/tempAccount'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'
import UserHistory from '@/components/UserHistory.vue'

// Used for notifications.
import {INotificationService} from '../services/NotificationService'
import UserService from '@/services/UserService'
import UserMireoService from '@/services/UserMireoService'
import TempAccountService from '@/services/TempAccountService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import Permissions from '../models/constants/Permissions'
import UserMIREO from '../models/userMireo'

import {sortStringValues} from '../utils/utils'
import UsersChangeStatus from "@/components/Users/UsersChangeStatus.vue";
import ChangeActivationKey from "@/components/Users/ChangeActivationKey.vue";

@Component({
  components: {
    ChangeActivationKey,
    UsersChangeStatus,
    ToolTipButton,
    AssignService,
    BlueButton,
    CardTable,
    ChangeEmail,
    CsvExport,
    DatePickerActions,
    DisplayActivationKey,
    EnableWifi,
    EndMission,
    HelpTooltip,
    RedButton,
    ResetPassword,
    ResetSinglePassword,
    SearchField,
    StartMission,
    TempAccountChangeStatus,
    TempAccountCreate,
    TempAccountDelete,
    TempAccountUpdate,
    CardTitle,
    UserHistory,
  },
})
export default class Cipeo extends Vue {
  public $refs!: {
    createDialog: TempAccountCreate,
    updateDialog: TempAccountUpdate,
    accountChangeStatusDialog: TempAccountChangeStatus,
    deleteDialog: TempAccountDelete,
    datePickerDialog: DatePickerActions,
    extendExpiryDate: DatePickerActions,
    extendMireoExpiryDate: DatePickerActions,
    userHistoryDialog: UserHistory,
    startMissionDialog: StartMission,
    endMissionDialog: EndMission,
    usersChangeStatusDialog: UsersChangeStatus,
    changeActivationKey: ChangeActivationKey,
  }
  @State private user!: any

  // User properties.
  private users: GenericUser[] = []
  private tempAccounts: TempAccount[] = []
  private filteredUsers: GenericUser[] = []
  private selectedUsers: GenericUser[] = []

  // UI properties.
  private searchFilter: string = ''
  private headers: GridHeader[] = []
  private establishments: Establishment[] = []
  private names: string[] = []
  private firstNames: string[] = []
  private userNames: string[] = []
  private functions: string[] = []
  private years: string[] = []
  private classes: string[] = []
  private sources: string[] = []
  private options = {
    itemsPerPage: 40,
  }
  private page: number = 1
  private isPending: boolean = true
  private dialog: boolean = false
  private changeEmailDialog: boolean = false
  private changeEmailMireoDialog: boolean = false
  private basicSearch: string = ''
  private descriptions: string[] = []
  private schools: Establishment[] = []

  private changeUserEmail!: GenericUser
  private changeMireoEmail!: GenericUser

  // Filter properties.
  private selectedEstablishmentId: string = ''
  private selectedSchoolIDFilter: string = ''
  private selectedSchoolName: string = ''
  private selectedName: string = ''
  private selectedFirstName: string = ''
  private selectedUsername: string = ''
  private selectedSource: string = ''
  // Used to handle errors
  private errorHandlerService: ErrorHandlerService

  // Used for notification.
  private $notificationService!: INotificationService

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  public mounted() {
    this.initialize()
  }

  private capitalize(value: string) {
    var trimmed_value = value.trimStart().trimEnd()
    return trimmed_value.charAt(0).toUpperCase() + trimmed_value.slice(1).toLowerCase()
  }

  private get filterSelection() {
    const filters = [
      'selectedSchoolIDFilter',
      'selectedName',
      'selectedFirstName',
      'selectedUsername',
      'selectedSource',
    ]
    return filters.filter(
        (filter) => this.$data[filter] !== '' && this.$data[filter] !== null,
    )
  }

  private get hasAccessToModifyStudentWifi(): boolean {
    const allowed = [Permissions.ModifyStudentWifi]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToManageSchoolStaffAccounts(): boolean {
    const allowed = [Permissions.ManageSchoolStaffAccounts]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToSearchMultiSchool(): boolean {
    const allowed = [Permissions.SearchMultiSchool]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToChangeEmail(): boolean {
    const allowed = [Permissions.ChangeEmail]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToCSVExport(): boolean {
    const allowed = [Permissions.ExportAccountsToCsv]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToChangeActivationKey(): boolean {
    const allowed = [Permissions.ChangeActivationKey]
    if ((this.user.permissions as []).some((permission) => allowed.includes(permission))) {
      return true
    }
    return false
  }

  private get hasAccessToChangeStatusOfStudents(): boolean {
    const allowed = [Permissions.ChangeStatusOfStudents]
    if ((this.user.permissions as []).some((permission) => allowed.includes(permission),)) {
      return true
    }
    return false
  }

  private get hasAccessToResetYear(): boolean {
    const allowed = [Permissions.ResetYearStudentsPassword]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private hasAccessToManageThisUser(user: GenericUser) {
    if (user.fonctions === 'Élève') {
      return this.hasAccessToModifyStudentWifi
    } else {
      return this.hasAccessToManageSchoolStaffAccounts
    }
  }

  private get hasAccessToManageTempUser(): boolean {
    const allowed = [Permissions.ManageTempAccounts]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private async fetchDescriptions() {
    this.isPending = true
    try {
      this.descriptions = await TempAccountService.fetchDescriptions()
    } catch (error: any) {
      if (error.response !== undefined) {
        this.descriptions = []
      }
    } finally {
      this.isPending = false
    }
  }

  private isMissionStarted(user: UserMIREO) {
    const date_validite = new Date(user.date_validite)
    if (
        user.etablissement_nom !== '' &&
        user.etablissement_nom !== undefined &&
        date_validite.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
    ) {
      return true
    }
    return false
  }

  private async search(filter: string | null) {
    if (filter) {
      this.isPending = true
      try {
        this.users = await UserService.search(filter)
        for (const user of this.users) {
          this.populateData(user)
        }
        this.sortData()
        this.filterLogical()
      } catch (error: any) {
        if (error.response !== undefined) {
          this.errorHandlerService.handle(this, error.response.data.code, true)
        }
      } finally {
        this.isPending = false
      }
    }
  }

  @Watch('searchFilter')
  private async onFilterChanged(searchFilter: string, oldsearchFilter: string) {
    this.clearDataTable()
    if (!searchFilter) {
      return
    }
    if (searchFilter.length >= 3) {
      // Prevents sending request while typing
      await new Promise((resolve) => setTimeout(resolve, 1000))
      if (!this.isPending && this.searchFilter === searchFilter) {
        this.search(searchFilter)
      }
    }
  }

  private capitalizeUserFunctions(user: GenericUser) {
    if (user.fonctions) {
      const userFunctions = user.fonctions.split(',')
      const capitalizedUserFonctions: string[] = []
      userFunctions.forEach((userFunction) => {
        const capitalizedUserFonction = this.capitalize(userFunction)
        capitalizedUserFonctions.push(capitalizedUserFonction)
        user.fonctions = capitalizedUserFonctions.join(',')
      })
    }
  }

  private populateData(user: GenericUser) {
    this.populateNames(user)
    this.populateFirstNames(user)
    this.populateUsernames(user)
    this.populateSource(user)
    this.capitalizeUserFunctions(user)
  }

  private sortData() {
    sortStringValues(this.names)
    sortStringValues(this.firstNames)
    sortStringValues(this.userNames)
    sortStringValues(this.sources)
  }

  private populateSchoolsForFilter() {
    const usersSchools = new Set()
    this.users.forEach((user) => {
      const schoolID = parseInt(user.etablissement_id, 10)
      if (schoolID) {
        usersSchools.add(schoolID)
      }
    })
    this.schools = this.establishments.filter((school) =>
        usersSchools.has(school.etablissement_id),
    )
  }

  private populateNames(user: GenericUser) {
    if (user.nom) {
      if (!this.names.includes(user.nom)) {
        this.names.push(user.nom)
      }
    }
  }

  private populateFirstNames(user: GenericUser) {
    if (user.prenom) {
      if (!this.firstNames.includes(user.prenom)) {
        this.firstNames.push(user.prenom)
      }
    }
  }

  private populateUsernames(user: GenericUser) {
    if (user.identifiant) {
      if (!this.userNames.includes(user.identifiant)) {
        this.userNames.push(user.identifiant)
      }
    }
  }

  private populateSource(user: GenericUser) {
    if (user.source) {
      if (!this.sources.includes(user.source)) {
        this.sources.push(user.source)
      }
    }
  }

  private filterLogical() {
    this.$emit('update:page', this.page)
    this.selectedUsers = []
    this.clearFiltersData()
    this.filteredUsers = this.users.filter((user) => {
      if (
          this.selectedSchoolIDFilter &&
          !user.etablissements.includes(this.selectedSchoolIDFilter)
      ) {
        return false
      }
      if (this.selectedName && user.nom !== this.selectedName) {
        return false
      }
      if (this.selectedFirstName && user.prenom !== this.selectedFirstName) {
        return false
      }
      if (this.selectedUsername && user.identifiant !== this.selectedUsername) {
        return false
      }
      if (this.selectedSource && user.source !== this.selectedSource) {
        return false
      }
      this.populateData(user)
      return true
    })
    this.populateSchoolsForFilter()
    this.sortData()
  }

  private get hasUsersToFilter() {
    return this.users.length > 0
  }

  private get hasSearchFilter() {
    return this.searchFilter !== '' && this.searchFilter !== null
  }

  private clearSearch() {
    this.searchFilter = ''
    this.clearDataTable()
  }

  private clearDataTable() {
    this.clearFiltersSelection()
    this.clearFiltersData()
    this.users = []
    this.selectedEstablishmentId = ''
    this.selectedSchoolName = ''
  }

  private clearFiltersSelection() {
    this.selectedName = ''
    this.selectedFirstName = ''
    this.selectedUsername = ''
    this.selectedSchoolIDFilter = ''
    this.selectedSource = ''
  }

  private clearFiltersData() {
    this.filteredUsers = []
    this.selectedUsers = []
    this.names = []
    this.firstNames = []
    this.userNames = []
    this.sources = []
  }

  private resetFilterDialog() {
    this.clearFiltersSelection()
    this.filterLogical()
  }

  private resetFilter(item) {
    this.$data[item] = ''
    this.filterLogical()
  }

  private canFilter(): boolean {
    return !!this.selectedSchoolName || !!this.searchFilter
  }

  private get usersToExport() {
    return this.selectedUsers.length > 0
        ? this.selectedUsers
        : this.filteredUsers
  }

  private async resetPassword(user: GenericUser) {
    this.isPending = true
    const username = user.identifiant
    const userType = user.fonctions === 'Élève' ? 'student' : 'schoolStaff'
    try {
      let response
      switch (user.source) {
        case 'PARTENAIRE':
          response = await TempAccountService.resetUserPassword(user)
          break
        case 'ELEVE':
          response = await UserService.resetUserPassword(
              user,
              user.etablissement_id,
              'student',
          )
          user.password = response['password']
          user.hasResetPassword = true
          break
        case 'ENSEIGNANT':
        case 'PERSONNEL':
          response = await UserService.resetUserPassword(
              user,
              user.etablissement_id,
              'schoolStaff',
          )
          break
        case 'REMPLACANT':
          response = await UserMireoService.resetUserPassword(
              user,
              user.etablissement_id,
          )
          break
      }
      if (user.source === 'ELEVE') {
        this.$notificationService.success(
            this.$t('USER.ResetPasswordSucceedStudent').toString() + username,
        )
      } else {
        this.$notificationService.success(
            this.$t('USER.ResetPasswordSucceedNotStudent').toString() +
            username +
            this.$t('USER.ResetPasswordSucceedNotStudent2').toString() +
            response['email'],
        )
      }
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
  }

  private getSelectedRowsCount() {
    return this.selectedUsers.length
  }

  private initialize() {
    this.establishments = Object.assign([], this.user.schools)
    this.createHeaders()
    this.fetchDescriptions()
  }

  private createHeaders() {
    this.headers.push(
        new GridHeader(this.$t('Name').toString(), 'nom', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(
            this.$t('FirstName').toString(),
            'prenom',
            'left',
            true,
            100,
        ),
    )
    this.headers.push(
        new GridHeader(
            this.$t('Username').toString(),
            'identifiant',
            'left',
            true,
            100,
        ),
    )
    this.headers.push(
        new GridHeader(this.$t('Email').toString(), 'courriel', 'left', true, 100),
    )
    this.headers.push(
        new GridHeader(
            this.$t('EmailRecovery').toString(),
            'courriel_autre',
            'left',
            true,
            100,
        ),
    )
    this.headers.push(
        new GridHeader(
            this.$t('Source').toString(),
            'source',
            'left',
            true,
            100,
        ),
    )
    this.headers.push(
        new GridHeader(
            this.$t('ADEnabled').toString(),
            'ad_est_actif',
            'center',
            true,
            25,
        ),
    )
    this.headers.push(
        new GridHeader(
            this.$t('ADSyncState').toString(),
            'etat_ad',
            'center',
            true,
            25,
        ),
    )
    this.headers.push(
        new GridHeader(
            this.$t('Actions').toString(),
            'actions',
            'left fixed',
            false,
            '5%',
            'fixed',
        ),
    )
  }

  private showUserHistoryOnRowClicked(payload: any) {
    this.showUserHistory(payload)
  }

  private create() {
    this.$refs.createDialog.show()
  }

  private update(tempAccount: TempAccount, step: number = 0) {
    this.$refs.updateDialog.show(this.tempAccounts, tempAccount, step)
  }

  private accountChangeStatus(tempAccount: TempAccount) {
    this.$refs.accountChangeStatusDialog.show(tempAccount)
  }

  private remove(tempAccount: TempAccount) {
    this.$refs.deleteDialog.show(this.tempAccounts, tempAccount)
  }

  private updateExpiryDate(tempAccount: TempAccount) {
    this.$refs.datePickerDialog.show(tempAccount)
  }

  private updateMireoExpiryDate(userMireo: UserMIREO) {
    this.$refs.extendMireoExpiryDate.show(userMireo)
  }

  private usersChangeStatus(user: User) {
    this.$refs.usersChangeStatusDialog.show(user)
  }

  private resetActivationKey(user: User) {
    this.$refs.changeActivationKey.show(user)
  }

  private startMission(account: UserMIREO) {
    this.$refs.startMissionDialog.show(account)
  }

  private endMission(account: UserMIREO) {
    this.$refs.endMissionDialog.show(account)
  }

  private showUserHistory(account: GenericUser) {
    this.$refs.userHistoryDialog.show(account)
  }

  private async handlePickerSelection(event: DatePickerActions) {
    this.isPending = true
    try {
      await TempAccountService.extend(
          event.account.ad_personne_id,
          event.picker,
          event.account.identifiant,
      )
      this.$notificationService.success(
          this.$t('TEMPACCOUNT.ValidityDateSuccess').toString(),
      )
    } catch (error: any) {
      this.isPending = false
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
    this.handleDialogClose()
  }

  private async extendExpiryDate(event: DatePickerActions) {
    this.isPending = true
    try {
      await UserMireoService.extend(
          event.account.ad_personne_id,
          event.picker,
          event.account.identifiant,
          event.account.etablissement_id,
      )
      this.$notificationService.success(
          this.$t('MIREOACCOUNT.ValidityDateSuccess').toString(),
      )
    } catch (error: any) {
      this.isPending = false
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
    this.handleDialogClose()
  }

  private handleChangeActivationClose() {
    this.onFilterChanged(this.searchFilter, this.searchFilter)
  }

  private handleDialogClose() {
    this.onFilterChanged(this.searchFilter, this.searchFilter)
  }

  private showChangeEmailDialog(user: GenericUser) {
    this.changeUserEmail = user
    this.changeEmailDialog = true
  }

  private showChangeEmailMireoDialog(user: GenericUser) {
    this.changeMireoEmail = user
    this.changeEmailMireoDialog = true
  }

  private async saveMailChange(chosenEmail: string, username: string) {
    await UserService.updateMask(chosenEmail, username)
  }

  private async saveMailChangeMIREO(chosenEmail: string, username: string) {
    await UserMireoService.updateMireoMask(chosenEmail, username)
  }

  private closeMailChangeDialog() {
    this.changeEmailDialog = false
    this.changeEmailMireoDialog = false
  }

  private getShoolName(idSeneps) {
    return this.establishments.find(
        (school) => school.etablissement_id === idSeneps,
    )?.nom
  }
}
